import "./language.css";
export function Language() {
  return (
    <section className="language">
      <h5>Spanish</h5>
      <p> Spanish native speaker</p>
      <h5>English</h5>
      <p> C1 Level</p>
    </section>
  );
}
